export default __webpack_public_path__ + "static/media/arteriogram.310eb82d.pdf";